import React from "react";
import { motion } from "framer-motion";
import useTitle from "../../hooks/useTitle";

// components
import AboutSection from "../../components/About/AboutSection";
import SkillSetSection from "../../components/About/SkillSetSection";

const hrVariants = {
	initial: {
		width: 0,
	},
	animate: {
		width: "100%",
	},
	view: {
		width: "100%",
	},
	exit: {
		width: 0,
	},
	transition: {
		duration: 3,
	},
};

const AboutPage = () => {
	useTitle("About");

	return (
		<div className="flex flex-col">
			<AboutSection />
			<motion.hr
				variants={hrVariants}
				{...hrVariants}
				className="my-10 border-green-800"
			/>
			<SkillSetSection />
		</div>
	);
};

export default AboutPage;
